import profileAxios from './profileAxios'

export const profile = (username) => {
  return profileAxios.get(`/profile/${username}`)
}

export const putProfile = (profile) => {
  return profileAxios.put(`/profile/update`, profile)
}

export const getOtp = () => {
  return profileAxios.get(`/profile/otp`)
}